import { render, staticRenderFns } from "./PlanUpdateModal.vue?vue&type=template&id=6479489c&scoped=true"
import script from "./PlanUpdateModal.vue?vue&type=script&lang=js"
export * from "./PlanUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./PlanUpdateModal.vue?vue&type=style&index=0&id=6479489c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6479489c",
  null
  
)

export default component.exports